import React from "react";
import { Box, SwipeableDrawer } from '@mui/material';
import VisualiserCandidatDrawer from "../../pages/Candidat/VisualiserCandidat/VisualiserCandidatDrawer";
import { useDispatch, useSelector } from "react-redux";
import { undisplaySwipeableDrawerSummary } from "../../redux/SwipeableDrawer/actions/swipeableDrawerActions";
import { TABLE } from "../../enums/tablesEnum";
import VisualiserContactDrawer from "../../pages/Contact/VisualiserContact/VisualiserContactDrawer";

const SwipeableDrawerSummary = () => {
  const dispatch = useDispatch();
  const swipeableDrawer = useSelector((state) => state.swipeableDrawer);
  const drawerWidth = "clamp(620px, 72vw, 760px)";

  const Frame = () => {
    switch (swipeableDrawer.table) {
      case "candidat":
        return (
          <VisualiserCandidatDrawer
            idCandidat={swipeableDrawer.idCandidatSelected}
          />
        );
      case TABLE.CONTACT:
        return (
          <VisualiserContactDrawer
            idContact={swipeableDrawer.idContactSelected}
            id={swipeableDrawer.idSocieteSelected}
          />
        );
      case TABLE.SOCIETE:
        return <Box>Not implemented</Box>;
      default:
        return <Box>Not implemented</Box>;
    }
  };

  return (
    <SwipeableDrawer
      anchor="right"
      open={swipeableDrawer.show}
      onClose={() => dispatch(undisplaySwipeableDrawerSummary())}
      onOpen={() => {}}
      sx={{
        "& .MuiDrawer-paper": {
          left: "auto !important",
          right: "0 !important",
          width: `${drawerWidth} !important`,
          minWidth: "320px",
          maxWidth: `${drawerWidth} !important`,
          background: "linear-gradient(180deg, #f8fbff 0%, #eef4fa 100%)",
          borderRadius: "0 !important",
          border: "0 !important",
          boxShadow: "-18px 0 46px rgba(15, 23, 42, 0.22)",
          overflow: "hidden",
          "& > .MuiBox-root": {
            width: "100% !important",
            maxWidth: "100% !important",
          },
          "@media (max-width: 900px)": {
            width: "100vw !important",
            minWidth: "100vw",
            maxWidth: "100vw !important",
          },
        },
      }}
      slotProps={{ paper: {
        sx: {
          left: "auto !important",
          right: "0 !important",
          width: `${drawerWidth} !important`,
          minWidth: "320px",
          maxWidth: `${drawerWidth} !important`,
          background: "linear-gradient(180deg, #f8fbff 0%, #eef4fa 100%)",
          borderRadius: "0 !important",
          border: "0 !important",
          boxShadow: "-18px 0 46px rgba(15, 23, 42, 0.22)",
          overflow: "hidden",
          "@media (max-width: 900px)": {
            width: "100vw !important",
            minWidth: "100vw",
            maxWidth: "100vw !important",
          },
        },
      } }}
    >
      <Box
        sx={{
          width: drawerWidth,
          minWidth: "320px",
          maxWidth: drawerWidth,
          height: "100vh",
          marginY: 0,
          background: "linear-gradient(180deg, #f8fbff 0%, #eef4fa 100%)",
          overflow: "hidden",
          "@media (max-width: 900px)": {
            width: "100vw",
            minWidth: "100vw",
            maxWidth: "100vw",
          },
        }}
      >
        <Frame />
      </Box>
    </SwipeableDrawer>
  );
};

export default SwipeableDrawerSummary;
